import React, { Dispatch } from 'react';
import classnames from 'classnames';
import { IAPIGameItem } from '../../../../model/api-modules';
import { RbacRoleObjectKey } from '../../../../model/rbac';
import styles from './index.module.scss';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  GamesAction,
  ReduxGamesActionType,
} from '../../../../store/modules/games';
// import { GameNameCube } from '../../../../components/game-name-cube';
import { Popover } from 'antd';
import StudioSetUp from '../../../../assets/svg/studio-set-up.svg';
import StudioSetUpHover from '../../../../assets/svg/studio-set-up-hover.svg';
import gameCardAdd from '../../../../assets/svg/game-card-add.svg';
import gameCardAddDisabled from '../../../../assets/svg/game-card-add-disabled.svg';
import { GameAvatar } from '../../../game-content/common/game-avatar';
import getFormatMessage from '../../../../locales/get-format-message';
import { PermissionCheck } from '../../../component/permission-check';
import { fetchUserPermission } from '../../../../store/modules/permission';
import { ModalWrap } from '../../../../components/modal-wrap';

interface IProps {
  readonly info?: IAPIGameItem;
  readonly addItem?: boolean;
  readonly addItemClick?: () => void;
  readonly disabled?: boolean;
}

export const GameCard = (props: IProps) => {
  const history = useHistory();
  const permissionDispatch = useDispatch<any>();
  const gameDispatch = useDispatch<Dispatch<GamesAction>>();
  const bgClassName = Math.random() > 0.5 ? 'card-bg-1' : 'card-bg-2';
  const onClickCard = () => {
    if (props?.addItemClick) {
      props.addItemClick();
    }
  };

  const goSetup = async (ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    ev.stopPropagation();
    const checkRes = await checkGamePermission();
    if (!checkRes) {
      return;
    }
    if (props.info) {
      gameDispatch({
        type: ReduxGamesActionType.SELECT_GAME,
        result: props.info,
      });
      history.push(`/console/game-info/${props.info?.gameID}`);
    }
  };

  const checkGamePermission = async () => {
    const permissionInfo = await fetchUserPermission(permissionDispatch)({
      gameID: props.info?.gameID,
    });
    const hasGamePermission = !!permissionInfo.gamePerm.length;
    if (!hasGamePermission) {
      ModalWrap.warn({
        title: getFormatMessage('no_permission_title'),
        children: <span>{getFormatMessage('no_rbac_permission_action')}</span>,
        oKText: getFormatMessage('i_know'),
        maskClosable: true,
      });

      return false;
    }
    return true;
  };

  const goGamePage = async () => {
    const checkRes = await checkGamePermission();
    if (!checkRes) {
      return;
    }
    if (props.info) {
      gameDispatch({
        type: ReduxGamesActionType.SELECT_GAME,
        result: props.info,
      });
      history.push(`/console/overview/${props.info?.gameID}`);
    }
  };
  const AddButton = (addIconProps: { disabled?: boolean }) => {
    return (
      <div
        className={classnames(
          styles.gameCard,
          styles.isAddItem,
          addIconProps?.disabled && styles.disabled
        )}
        onClick={addIconProps.disabled ? undefined : onClickCard}
      >
        {addIconProps.disabled ? (
          <img src={gameCardAddDisabled} className={styles.iconAdd} />
        ) : (
          <img src={gameCardAdd} className={styles.iconAdd} />
        )}
        <span className={styles.addItemText}>
          {getFormatMessage('create_new_title')}
        </span>
      </div>
    );
  };
  const renderCardItem = () => {
    return (
      <div className={styles.cardContent} onClick={goGamePage}>
        <div className={styles.cardHead} onClick={goSetup}>
          <span className={styles.setupBtn}>
            <img src={StudioSetUp} className={styles.icon} />
            <img src={StudioSetUpHover} className={styles.iconHover} />
          </span>
        </div>
        <div className={styles.cardBody}>
          {props.info ? (
            <GameAvatar
              width="48px"
              name={props.info.gameName}
              color={props.info.gameColor}
              fontSize="28px"
            />
          ) : null}

          <div className={styles.gameInfo}>
            <Popover
              overlayClassName={styles.infoItemPopover}
              content={props.info?.gameName}
              trigger="hover"
              placement="topLeft"
            >
              <p className={classnames(styles.infoItem, styles.isName)}>
                {props.info?.gameName}
              </p>
            </Popover>
            <div className={styles.cardFooter}>
              {getFormatMessage('title_id')}: {props.info?.gameID}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderCard = () => {
    if (props?.addItem) {
      return (
        <PermissionCheck permissionKey={RbacRoleObjectKey.GameCreate}>
          <AddButton />
        </PermissionCheck>
      );
    }
    return (
      <div
        className={classnames(styles.gameCard, bgClassName)}
        onClick={onClickCard}
      >
        {renderCardItem()}
      </div>
    );
  };

  return renderCard();
};
